module.exports = __webpack_public_path__ + "img/outcome_05.9a4e87d6.png";